import React from 'react'
import Button from '@mui/material/Button'
import { IoSparkles } from 'react-icons/io5'
import { moduleEnabledOrOpenIntercom } from '@/javascript/helpers/validate_module'

type Props = {
  onClick: () => void
  contracted: boolean
}

const SuggestionButton: React.FC<Props> = ({ onClick, contracted }) => {
  const handleClick = () => {
    moduleEnabledOrOpenIntercom(
      contracted,
      onClick,
      'Olá! Quero usar a Manu IA para criar os formulários no sistema. ' +
        'Perco muito tempo definindo os campos e ela pode sugerir isso automaticamente.\n' +
        'Pode me explicar como contratar?'
    )
  }
  return (
    <>
      <Button color='primary' variant="outlined" size="medium" startIcon={<IoSparkles size={16} />}
        onClick={handleClick}
      >
        Preencher com IA
      </Button>
    </>
  )
}

export default SuggestionButton
